
/** Contains a user-friendly name for the page like home */
export function usePageName(pathname = location.pathname) {
  const uriParts = pathname.split('/').filter(Boolean);
  if (uriParts.length === 0) {
    return "home"
  }
  return uriParts.join('-');
}